import z from "zod"

/**
 * ColetaPrecoSchema
 */

export const ColetaPrecoSchema = z.object({
  status: z.coerce.number({ required_error: 'Este campo deve ser preenchido!' }),
  nro: z.coerce.number().optional(),
  dataCadastro: z.coerce.date(),
  idRequisicaoCompra: z.coerce.number().optional(),
  dataColeta: z.coerce.date().optional(),
  centroCusto: z.coerce.number().optional(),
  idSubconta: z.coerce.number().optional(),
  idFuncionarioComprador: z.coerce.number().optional(),
  idFuncionarioAprovado: z.coerce.number().optional(),
  idFuncionarioAprovadores: z.array(z.coerce.number()).optional(),
  arquivo1: z.instanceof(File).optional(),
  limparArquivo1: z.boolean().default(false),
  arquivo2: z.instanceof(File).optional(),
  limparArquivo2: z.boolean().default(false),
  arquivo3: z.instanceof(File).optional(),
  limparArquivo3: z.boolean().default(false),
}).superRefine((data, ctx) => {
  if (data.idRequisicaoCompra === undefined) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Este campo deve ser preenchido!',
      path: ['idRequisicaoCompra'],
    });
  }
});

/**
 * ColetaPrecoForm
 */

export type ColetaPrecoForm = z.infer<typeof ColetaPrecoSchema>;

/**
 * initialColetaPrecoForm
 */

export const initialColetaPrecoForm: Partial<ColetaPrecoForm> = {
  status: 0,
};